import endpoint from "../../config/endpoints";

export const beatJson = {
  showSaveNextBtn: true,
  formPath: "/beat-form",
  apiBaseURL: endpoint.beat,
  changeExcel: endpoint.exportData,
  screenTitle: "Beat",
  searchButtonGrid: 1,
  showAddButton: true,
  showPdfDownload: true,
  pdfFileName: "Beat",
  showExcelDownload: true,
  excelFileName: "Beat",
  excelUrl: "beat-data-new" + '?sort={"sortOrderNo": "ASC"}',
  formPathView: "/beat-view",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Name",
      columnKeyName: "beatName",
      isChecked: true,
    },
    {
      columnDisplayName: "Area",
      columnKeyName: "areaName",
      isChecked: true,
    },
    {
      columnDisplayName: "Outlet Count",
      columnKeyName: "outletCount",
      isChecked: true,
    },
    {
      columnDisplayName: "Sort Order Number",
      columnKeyName: "sortOrderNo",
      isChecked: true,
    },
    {
      columnDisplayName: "Status",
      columnKeyName: "isActive",
      isChecked: true,
    },
  ],
  searchList: [
    {
      label: "Region",
      controlType: "autocomplete",
      placeHolder: "Select Region",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      masterName: "regionDetail",
      dataKey: "region",
      getListId: "region",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "State",
      controlType: "autocomplete",
      placeHolder: "Select State",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      masterName: "stateDetail",
      dataKey: "state",
      getListFrom: "region",
      getListId: "state",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Zone",
      controlType: "multiSelect",
      placeHolder: "Select Zone",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      masterName: "zoneDetail",
      dataKey: "zone",
      getListFrom: "state",
      getListId: "zone",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "District",
      controlType: "multiSelect",
      placeHolder: "Select District",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      masterName: "districtDetail",
      dataKey: "district",
      getListFrom: "zone",
      getListId: "district",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Taluka",
      controlType: "multiSelect",
      placeHolder: "Select Taluka",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      masterName: "talukaDetail",
      dataKey: "taluka",
      getListFrom: "district",
      getListId: "taluka",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      masterName: "areaDetail",
      dataKey: "area",
      getListFrom: "taluka",
      getListId: "area",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
  fieldMeta: [
    {
      label: "Area",
      controlType: "autocomplete",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaForBeatDetail",
      dataKey: "area",
      isRootLevelKey: false,
      isMandatory: true,
    },
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Beat Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "beatName",
      isMandatory: true,
      autoFocus: true,
    },

    {
      label: "Sort Order No",
      controlType: "textfield",
      placeHolder: "Sort Order",
      inputType: "number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "sortOrderNo",
      isMandatory: true,
    },
  ],
  fieldMetaForTown: [
    {
      label: "Area",
      controlType: "autocomplete",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaForBeatDetail",
      dataKey: "area",
      isRootLevelKey: false,
      isMandatory: true,
    },
    {
      label: "Town",
      controlType: "autocomplete",
      placeHolder: "Select Town",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "townDetail",
      dataKey: "townId",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Beat Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "beatName",
      isMandatory: true,
      autoFocus: true,
    },

    {
      label: "Sort Order No",
      controlType: "textfield",
      placeHolder: "Sort Order",
      inputType: "number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "sortOrderNo",
      isMandatory: true,
    },
  ],

  fieldMetaForBeatType: [
    {
      label: "Area",
      controlType: "autocomplete",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaForBeatDetail",
      dataKey: "area",
      isRootLevelKey: false,
      isMandatory: true,
    },
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Beat Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "beatName",
      isMandatory: true,
      autoFocus: true,
    },
    {
      label: "Sort Order No",
      controlType: "textfield",
      placeHolder: "Sort Order",
      inputType: "number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "sortOrderNo",
      isMandatory: true,
    },

    {
      label: "Beat Type",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Working",
          value: "0",
        },
        {
          label: "Non Working",
          value: "1",
        },
      ],
      isMandatory: true,
    },

    {
      label: "Distance From HQ (KM)",
      controlType: "textfield",
      placeHolder: "Enter Distance",
      inputType: "number",
      spValid: "float",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "distanceFromHQ",
      defaultValue: "0",
      isMandatory: true,
    },
  ],
  fieldMetaForBeatTypeTown: [
    {
      label: "Area",
      controlType: "autocomplete",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaForBeatDetail",
      dataKey: "area",
      isRootLevelKey: false,
      isMandatory: true,
    },
    {
      label: "Town",
      controlType: "autocomplete",
      placeHolder: "Select Town",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "townDetail",
      dataKey: "townId",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Name",
      controlType: "textfield",
      placeHolder: "Beat Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "beatName",
      isMandatory: true,
      autoFocus: true,
    },
    {
      label: "Sort Order No",
      controlType: "textfield",
      placeHolder: "Sort Order",
      inputType: "number",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "sortOrderNo",
      isMandatory: true,
    },

    {
      label: "Beat Type",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Working",
          value: "0",
        },
        {
          label: "Non Working",
          value: "1",
        },
      ],
      isMandatory: true,
    },

    {
      label: "Distance From HQ (KM)",
      controlType: "textfield",
      placeHolder: "Enter Distance",
      inputType: "number",
      spValid: "float",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "distanceFromHQ",
      defaultValue: "0",
      isMandatory: true,
    },
  ],
};
